var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBoth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 38,
    viewBox: "0 0 19 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_4",
    "data-name": "\\uB2E4\\uAC01\\uD615 4",
    d: "M9.5,0,19,16H0Z",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_5",
    "data-name": "\\uB2E4\\uAC01\\uD615 5",
    d: "M9.5,0,19,16H0Z",
    transform: "translate(19 38) rotate(180)",
    fill: "#29b6f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoth);
export default __webpack_public_path__ + "static/media/ArrowBoth.39d86a83ce4fe742afa5f827b483860c.svg";
export { ForwardRef as ReactComponent };